interface SpinnerProps {
  size?: 'sm' | 'md';
  className?: string;
}

export default function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  return <span className={`${size === 'sm' ? 'spinner-sm' : 'spinner'} ${className}`} />;
}
